

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import devVar from './dev-variable/dev-variable.js'
import _ from 'lodash'


import vueg from 'vueg'



import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'



import utils from './tools/utils'
import http from './tools/http'
import api from './tools/api'
import dsBridge from 'dsbridge'


if (process.env.NODE_ENV === 'development') {
let VConsole = require('vconsole')
const vConsole = new VConsole()
}

Vue.component('x-header', XHeader)
Vue.component('loading', Loading)
Vue.component('x-input', XInput)
Vue.component('group', Group)
Vue.component('x-button', XButton)
Vue.component('alert', Alert)
Vue.component('toast', Toast)
Vue.component('inlineLoading', InlineLoading)

Vue.prototype.utils = utils
Vue.prototype.http = http
Vue.prototype.api = api
Vue.prototype.router = router
Vue.prototype.devVar = devVar
Vue.prototype.localDev = window.location.hostname === 'zhihui-more'


Vue.use(_)

Vue.use(vueg, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>',
created () {
this.$store.commit('setTitle', '登录验证')
this.$store.commit('setLeftOptions', {
showBack: false,
backText: ''
})
},
computed: {
getProductName () {
return this.$store.state.productName
}
},
watch: {
getProductName (val) {
if (val.length > 0) {
this.login()
}
}
},
methods: {
login () {
let me = this
let flag = true

dsBridge.call('getBaseInfo', function (res) {
let RES = JSON.parse(res)

if (RES) {
flag = false

if (RES.product_code === 'JW_system') {
me.otherLogin(RES.g_person_id, RES.name, RES.product_code)
} else {
me.getRouters() 
}
} else {
store.commit('setGlobalAlertStatus', true)
store.commit('setGlobalAlertText', '无权限，您无法使用此功能！')
}
})


setTimeout(() => {
if (flag && (process.env.NODE_ENV === 'development' || me.localDev)) {

if (me.devVar.product_code === 'JW_system') {
me.otherLogin(me.devVar.g_person_id, me.devVar.name, me.devVar.product_code)
} else {
me.getRouters() 
}
}
}, 1000)
},
async getRouters () {
let product = sessionStorage.getItem('productName')
let routerData = await Vue.prototype.http.get('/static/config/' + product + '/permission-' + product + '.json', '', 'noApi')
sessionStorage.setItem('router', JSON.stringify(routerData))
Vue.prototype.router.addRoutes(Vue.prototype.utils.dynamicRouter(routerData))
Vue.prototype.router.addRoutes([{path: '*', redirect: '/404'}])
this.$router.push('/')
},

async otherLogin (gPersonId, name, productCode) {
let me = this
me.utils.removeLocalStorage(productCode)

let postData = {
grant_type: 'password',
g_person_id: gPersonId,
name: name
}
let url = me.localDev ? 'http://jw.yachedu.com/api/account/app-login' : '/api/account/app-login'
let loginRes = await me.http.post(url, postData)
if (loginRes.success === 'Success') {

me.utils.setLocalStorage(productCode, loginRes.data)
me.getRouters()
me.loading = false
} else {
me.hasRole = true
}
}
}
})



// WEBPACK FOOTER //
// ./src/main.js